import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox } from 'devextreme-react';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { confirm } from 'devextreme/ui/dialog';
let quantityBillAs = "";
let chargeid = "";
const InvoiceHeaderDetailsTab = (props) => {
    const dataGrid = useRef(null);
    var url = "wm/UpdateInvoice/GetInvoiceDetails";
    var updateUrl = "wm/UpdateInvoice/UpdateInvoiceDetails";
    var insertUrl = "wm/UpdateInvoice/AddInvoiceDetails";
    var deleteUrl = "wm/UpdateInvoice/DeleteInvoiceDetails";
    const dataSource = createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        deleteUrl: `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.headerId
            };
        },
        onInserted: function (e) {
            props.UpdateTotalAmount();
        },
        onUpdated: function (e) {
            props.UpdateTotalAmount();
        },
        onRemoved: function (e) {
            props.UpdateTotalAmount();
        }
    });
    var chargesUrl = "wm/UpdateInvoice/GetCharges";
    const getCharges = () => {
        const selectBoxData = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${chargesUrl}`,
                key: 'rowid',
                loadParams: {
                    customerIdentity: ''
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 10
        });
        return selectBoxData;
    };
    const [currentLayout, setCurrentLayout] = useState("Default");
    const gridKey = "2C98BA97-3926-4111-911F-B8AD9A533B71";
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    const renderChargesCell = (cellElement) => {

        const charges = getCharges()
        const currentValue = cellElement.row.data.chargeid;
        const qty = cellElement.row.data.quantityBillAs;
        return (
            <SelectBox
                dataSource={charges}
                valueExpr="rowid"
                displayExpr="code"
                defaultValue={currentValue}
                searchEnabled={true}
                searchMode="contains"
                searchExpr="code"
                onValueChanged={(e) => {
                    const selectedText = e.component.option('displayValue');
                    chargeid = e.value;
                    quantityBillAs = qty;
                    cellElement.setValue(selectedText);
                }}
            />

        );
    }
    const GetChargeCodeDetail = async (rowData, code) => {
        var url = "wm/UpdateInvoice/GetChargeCodeDetail";
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}?code=${code}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            console.error(responseData);
            if (responseData.success) {
                rowData.description = responseData.invoiceHeader?.description;
                rowData.rate = responseData.invoiceHeader?.rate;
                rowData.amount = responseData.invoiceHeader?.rate * quantityBillAs;
                rowData.quantityBillAs = quantityBillAs;
            } else {
                console.error('Failed to get item detail:');
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
            //setTimeout(hideLoadPanel, 1000);
        }

    }

    async function setStateValue(rowData, value) {

        try {
            await GetChargeCodeDetail(rowData, value);
            rowData.chargeid = chargeid;
            rowData.chargeCode = value;
        } catch (error) {
            console.error("Failed to fetch item data:", error);
        }
    }
    const deleteRecords = useCallback(() => {
        var deleteUrl = "wm/UpdateInvoice/DeleteInvoiceDetails";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                        selectedItemKeys,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                        props.UpdateTotalAmount();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                    });

            }
        });

    }, [selectedItemKeys]);
    const handleCellValueChanged = (data) => {
        
        setSelectedItemKeys(data.selectedRowKeys);
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Scrolling mode="standard" />
                <Selection mode="multiple" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="chargeCode" caption='Charge' editCellRender={renderChargesCell} setCellValue={setStateValue} allowEditing={props.formFields.STATUS !== 'Z'}>
                    <RequiredRule message="The chargeCode field is required." />
                </Column>
                <Column dataField="rowid" caption="Row ID" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="chargeid" caption="chargeid" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                {/* <Column dataField="chargeCode" caption="Charge" dataType="string"/> */}
                <Column dataField="description" caption="Description" allowEditing={false} dataType="string" />
                <Column dataField="chargeType" caption="Type" allowEditing={false} dataType="string" />
                <Column dataField="quantityBillAs" caption="Bill As" dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="rate" caption="Rate" dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="amount" caption="Amount" allowEditing={false} dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                />
                <Column dataField="userDefinedCode1" caption="User Defined Code 1" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedCode2" caption="User Defined Code 2" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedCode3" caption="User Defined Code 3" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'}c />
                <Column dataField="userDefinedCode4" caption="User Defined Code 4" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedDate1" caption="User Defined Date 1" dataType="date" format="MM/dd/yyyy" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedDate2" caption="User Defined Date 2" dataType="date" format="MM/dd/yyyy" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedDate3" caption="User Defined Date 3" dataType="date" format="MM/dd/yyyy" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedDate4" caption="User Defined Date 4" dataType="date" format="MM/dd/yyyy" visible={false} allowEditing={props.formFields.STATUS !== 'Z'} />
                <Column dataField="userDefinedQuantity1" caption="User Defined Quantity 1" dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="userDefinedQuantity2" caption="User Defined Quantity 2" dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="userDefinedQuantity3" caption="User Defined Quantity 3" dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="userDefinedQuantity4" caption="User Defined Quantity 4" dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} 
                    allowEditing={props.formFields.STATUS !== 'Z'}
                />
                <Column dataField="userDefinedComment" caption="User Defined Comment" dataType="string" visible={false} allowEditing={props.formFields.STATUS !== 'Z'}/>
                <Toolbar>
                    <Item
                        name="addRowButton"
                        disabled={props.formFields.STATUS === 'Z'}
                    />
                      <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length || props.formFields.STATUS === 'Z'}
                        />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(InvoiceHeaderDetailsTab);